import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { FormatarData } from "./../../../../shared/formatarData";
import { RetornoSelecao } from "./../../../../shared/gridview/RetornoSelecao";
import { Estado } from "./../../../../shared/shared/estado.enum";

@Component({
  selector: "app-bi-spuie",
  template: `<div class="color-bar"></div>

    <div>
      <app-bi-spuie-lista [filtros]="filtros" (exibir)="selecionar($event)">
      </app-bi-spuie-lista>
    </div>`,
  styleUrls: ["./bi-spuie.component.css"],
})
export class BiSpuieComponent implements OnInit {
  selecionado: object;
  state: Estado = Estado.view;
  filtros = {};
  InicialData; // Set the first Day of month
  max; // Set a max valid date
  min; // Set a min valid date
  parametrosFiltro: any;
  carregando: any;

  constructor(private route: ActivatedRoute) {
    this.route.queryParams.subscribe((params) => {
      this.parametrosFiltro = params;
      this.setaValorData(params["data_inicial"]);
      this.carregarFiltrosParametros();
    });
  }

  ngOnInit(): void {}

  setaValorData(dataInicial: Date) {
    const dt = new Date();
    if (dataInicial === undefined || dataInicial.toString() === "") {
      const dt = new Date();
      const dataInicial = {
        year: dt.getFullYear(),
        month: dt.getMonth() + 1,
        day: dt.getUTCDate(),
      };
      const dataInicialFormata = new FormatarData(
        dataInicial.year,
        dataInicial.month,
        dataInicial.day,
        0,
        0,
        0
      ).getDataString();
      this.InicialData = dataInicialFormata;
    } else {
      const now = new Date(dataInicial);
      this.InicialData =
        now.getFullYear() +
        "-" +
        ("0" + (now.getMonth() + 1)).slice(-2) +
        "-" +
        ("0" + now.getUTCDate()).slice(-2);
    }

    this.filtros = { data_inicial: this.InicialData };
  }

  carregarFiltrosParametros() {
    if (this.parametrosFiltro) {
      for (const item in this.parametrosFiltro) {
        if (this.parametrosFiltro.hasOwnProperty(item)) {
          this.filtros[item] = this.parametrosFiltro[item];
        }
      }
    }
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }
}
